import { Injectable, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegisterComponentsService {

  viewContainerRefs: ComponentInfo[] = [];
  onNewRegisterComponent$ = new Subject<ComponentInfo>();

  constructor(
  ) {}

  setViewContainerRef(componentInfo: ComponentInfo) {

    if (componentInfo.typeSection !== 'section') {
      this.viewContainerRefs.push(componentInfo);
    } else {

      const index = this.viewContainerRefs.findIndex(
        c => c.typeSection === 'section' && c.idSection === componentInfo.idSection
      );

      if (index !== -1) {
        this.viewContainerRefs.splice(index, 1);
      }

      this.viewContainerRefs.push(componentInfo);

    }

    this.onNewRegisterComponent$.next(componentInfo);
  }

  getViewContainerRef() {
    return this.viewContainerRefs || null;
  }

}


interface ComponentInfo {
  idSection: number,
  typeSection: TypeSection,
  viewRef: ViewContainerRef
}

type TypeSection = 'header' | 'section' | 'footer';
